import { render, staticRenderFns } from "./#zhiwei-edit.vue?vue&type=template&id=1d0f419c&"
import script from "./#zhiwei-edit.vue?vue&type=script&lang=js&"
export * from "./#zhiwei-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports